import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import HelpDialogLayout, { BodyTypographies, ContentStack, HelpDialogLayoutProps, SectionStack } from "./HelpDialogLayout";


export interface ExerciseDialogProps extends HelpDialogLayoutProps {}
export default function ExerciseDialog(props: ExerciseDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "体をしっかり動かした日はぐっすり眠れた、という経験をお持ちではないでしょうか。適度な運動習慣で日中に体をしっかり動かすことは、寝付きを良くし、中途覚醒の減少や深い眠りを導くことで睡眠の質を高めます。さらにストレス耐性を高め、メンタルを安定させる効果もあります。ぜひ運動をダイエットの手段としてだけでなく、睡眠やメンタルのためにも活用してみてください。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">おすすめの運動習慣</Typography>
          <BodyTypographies
            contents={[
              "中～高強度の運動が睡眠の質を改善したという報告は多く出ていますが、まずは低強度でも現実的に続けられ、かつ自分が気持ち良いと感じる運動から始めるのが良いでしょう。また運動の頻度は週1回よりも複数回行う方が効果的ですが、何よりもまずは習慣的に実行していくことが大切です。トイレに行った時にスクワットする、テレビを見ながらストレッチする、子供のお迎えに行くついでに10分ほど散歩する、など、普段の行動をきっかけに取り組める内容にすると継続しやすくなります。",
            ]}
          />
        </SectionStack>
        <Stack>
          <TableContainer
            sx={{
              borderRadius: 0,
              "& tr": {
                borderBottom: "1px solid #e0e0e0",
                "&:first-of-type": {
                  borderTop: "1px solid #e0e0e0",
                },
              },
              "& .MuiTableCell-root": {
                borderBottom: "none",
              },
              "& th.MuiTableCell-root": {
                px: 0,
                py: 2,
                width: "50%",
                backgroundColor: "#f6f5f4",
                "&:first-of-type": {
                  whiteSpace: "nowrap",
                },
                "&:not(:first-of-type) .MuiTypography-caption": {
                  borderLeft: "1px solid #e0e0e0",
                },
                "& .MuiTypography-caption": {
                  color: "#3d3d3d",
                  px: 2,
                },
              },
              "& td.MuiTableCell-root": {
                px: 2,
                py: 3,
                fontSize: "13px",
                verticalAlign: "top",
                "&:not(:first-of-type)": {
                  borderLeft: "1px solid #e0e0e0",
                },
              },
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="caption">運動の強度</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">運動の例</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>低強度</TableCell>
                  <TableCell>
                    家の中で歩く、ストレッチ、ヨガ、洗濯物の片付け、買い物、植物の水やりなど
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>中強度</TableCell>
                  <TableCell>
                    歩く（やや速めに）、軽い筋力トレーニング（スクワット）、水中歩行、太極拳、パワーヨガ、ピラティス、掃除機をかける、洗車など
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>高強度</TableCell>
                  <TableCell>
                    ジョギング、水泳、エアロビクス、サッカー、登山など
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
